// extracted by mini-css-extract-plugin
module.exports = {"filterSubheading":"Transactions_filterSubheading__1OFba","filterBody":"Transactions_filterBody__1XLWM"};